export class TipoOrgao {
  ativo: boolean;
  id: number;
  estadoId: number;
  codigoTCE: string;
  descricao: string;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/orgao-tipos/shared/orgao-tipo.model.ts
 **/